import Chart from 'chart.js';
import moment from 'moment';
export default {
    name: 'compare_reports',
    props: ['customer_data','revenue_data','selected_date','compare_condition'],
    data(){
        return{
            show_revenue_card:true,
            show_customer_pie_card:true,
            pie_chart_data_selected :{
                type: 'doughnut',
                data :{
                    labels: ['New', 'Returning','None'],
                    datasets: [
                        {  
                            data: [0, 0, 0],
                            backgroundColor : [
                                '#10A377',
                                '#FB6672',
                                '#EBEFF2'
                            ],
                        }
                    ],
                    options: {
                        legend: {
                            display: false,
                        },
                        tooltips:{
                            enabled:true
                        },
                    }
                },
                options: {
                    responsive: true,
                }

            },
            pie_chart_data_past :{
                type: 'doughnut',
                data :{
                    labels: ['New', 'Returning','None'],
                    datasets: [
                        {  
                            data: [0, 0, 0],
                            backgroundColor : [
                                '#10A377',
                                '#FB6672',
                                '#EBEFF2'
                            ],
                        }
                    ],
                    options: {
                        legend: {
                            display: false,
                        },
                        tooltips:{
                            enabled:true
                        },
                    }
                },
                options: {
                    responsive: true,
                }

            },
            current_start_date:'',
            current_end_date:'',
            past_start_date:'',
            past_end_date:''


        }
    },
    components: {
        Chart
    },
    created(){
        
    },
    mounted(){
        this.show_reports();
    },
  computed : {
      no_revenue_check(){
          this.show_revenue_card = false;
          this.show_customer_pie_card = false;
        if(this.revenue_data.current_revenue.total_revenue){
            this.show_revenue_card = true;
        }
        else if(this.compare_condition == 'year'){
            if(this.revenue_data.previous_year_revenue.total_revenue){
                this.show_revenue_card = true;
            }
        }
        else if(this.compare_condition == 'period'){
            if(this.revenue_data.previous_period_revenue.total_revenue){
                this.show_revenue_card = true;
            }
        }

        //customer pie chart hide condition cheking
        if(this.customer_data.customers_data.total_customers){
            this.show_customer_pie_card = true;
        }
        else if(this.compare_condition == 'year'){
            if(this.customer_data.prev_year_customers_data.total_customers_prev){
                this.show_customer_pie_card = true;
            }
        }
        else if(this.compare_condition == 'period'){
            if(this.customer_data.prev_period_customers_data.total_customers_prev){
                this.show_customer_pie_card = true;
            }
        }

        
      }
     
    },
    methods:{
        show_reports(){
            if(this.customer_data){
                this.pie_chart_data_selected.data.datasets[0].data[0] = this.customer_data.customers_data.new_customers;
                this.pie_chart_data_selected.data.datasets[0].data[1] = this.customer_data.customers_data.returning_customers;
                if(this.customer_data.customers_data.new_customers == 0 && this.customer_data.customers_data.returning_customers == 0) {
                    this.pie_chart_data_selected.data.datasets[0].data[2] = 100;
                    this.pie_chart_data_selected.data.options.tooltips.enabled = false
                }
                else  this.pie_chart_data_selected.data.options.tooltips.enabled = true
                
                if(this.compare_condition == 'period'){
                    this.pie_chart_data_past.data.datasets[0].data[0] = this.customer_data.prev_period_customers_data.new_customers_prev;
                    this.pie_chart_data_past.data.datasets[0].data[1] = this.customer_data.prev_period_customers_data.returning_customers_prev;
                    if(this.customer_data.prev_period_customers_data.new_customers_prev == 0 && this.customer_data.prev_period_customers_data.returning_customers_prev == 0) {
                        this.pie_chart_data_past.data.datasets[0].data[2] = 100;
                        this.pie_chart_data_past.data.options.tooltips.enabled = false
                    }
                    else this.pie_chart_data_past.data.options.tooltips.enabled = true
                
                }
                else if(this.compare_condition == 'year'){
                    this.pie_chart_data_past.data.datasets[0].data[0] = this.customer_data.prev_year_customers_data.new_customers_prev;
                    this.pie_chart_data_past.data.datasets[0].data[1] = this.customer_data.prev_year_customers_data.returning_customers_prev
                    if(this.customer_data.prev_year_customers_data.new_customers_prev == 0 && this.customer_data.prev_year_customers_data.returning_customers_prev == 0) {
                        this.pie_chart_data_past.data.datasets[0].data[2] = 100;
                        this.pie_chart_data_past.data.options.tooltips.enabled = false
                    }
                    else this.pie_chart_data_past.data.options.tooltips.enabled = true
                }
                if(this.show_customer_pie_card){
                    this.createChart('current_pie_chart',this.pie_chart_data_selected);
                    this.createChart('past_pie_chart',this.pie_chart_data_past);
                }
                
                this.current_start_date = this.selected_date[0];
                this.current_end_date = this.selected_date[1];

                var start = '';
                var end = '';
                var difference = '';
                if(this.compare_condition == 'period'){
                    start = moment(this.current_start_date);
                    end = moment(this.current_end_date);
                    difference = start.diff(end, 'days');
                    this.past_start_date = moment(this.current_start_date,'MMM D, YYYY').add((difference-1),'days').format('MMM D, YYYY');
                    this.past_end_date = moment(this.current_start_date,'MMM D, YYYY').add(-1,'days').format('MMM D, YYYY');
                    this.past_start_date = moment(this.revenue_data.prev_period_start_date).format('MMM D, YYYY');
                    this.past_end_date = moment(this.revenue_data.prev_period_end_date).format('MMM D, YYYY');
                }
                else if(this.compare_condition == 'year'){
                    start = moment(this.current_start_date);
                    end = moment(this.current_end_date);
                    difference = start.diff(end, 'days');
                    this.past_start_date = moment(this.current_start_date,'MMM D, YYYY').add(-365,'days').format('MMM D, YYYY');
                    this.past_end_date = moment(this.past_start_date,'MMM D, YYYY').add(-(difference),'days').format('MMM D, YYYY');
                    this.past_start_date = moment(this.revenue_data.previous_year_start_date).format('MMM D, YYYY');
                    this.past_end_date = moment(this.revenue_data.previous_year_end_date).format('MMM D, YYYY');
                }
            }
          },
        createChart(chartId,chartData) {
//            console.log(chartId)
            const ctx = document.getElementById(chartId);
            new Chart(ctx, {
              type: chartData.type,
              data: chartData.data,
              options : chartData.data.options
            });
        },
    }
}